import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import 'cally';
import { environment } from './environments/environment';

if (environment.name !== 'dev' && environment.name !== 'local') {
  Sentry.init({
    dsn: 'https://82b53249bab8e3f67a4b285e31f760c3@o557238.ingest.us.sentry.io/4509842262982656',
    sendDefaultPii: true,
    tracesSampleRate: 0.01,
    environment: environment.name,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    ],
    replaysSessionSampleRate: 0.005, // 0.5% of all sessions
    replaysOnErrorSampleRate: 0.05, // 5% of error sessions
    enableLogs: true,
    tracePropagationTargets: ['localhost', /^.*tracer.airgateway.*$/],
  });
}

bootstrapApplication(App, appConfig).catch(err => console.error(err));
